<template>
  <div>
    <p class="white" :title="place">{{ place }}</p>
    <p class="yet-another-grey">{{ studio }}</p>
    <p class="yet-another-grey">{{ startOn | date }} - {{ endOn | date }}</p>
  </div>
</template>

<script>
export default {
  name: 'Travel',
  props: ['place', 'studio', 'startOn', 'endOn'],
};
</script>

<style scoped>
  p {
    margin-bottom: 0px;
  }

  .yet-another-grey {
    color: #787878;
  }
</style>
